import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'label', label: 'Label', type: 'text' },
    { key: 'value', label: 'Display value', type: 'text', placeholder: 'e.g. 2.15 Lakh+' },
    { key: 'numeric_value', label: 'Numeric value (for counter)', type: 'number' },
    { key: 'suffix', label: 'Suffix', type: 'text', placeholder: '+, Lakh+, %' },
    { key: 'icon', label: 'Icon (lucide slug)', type: 'text' },
    { key: 'order', label: 'Order', type: 'number' },
];
const columns = [
    { key: 'label', label: 'Label', primary: true },
    { key: 'value', label: 'Value' },
    { key: 'numeric_value', label: 'Numeric' },
];
const defaultItem = {
    label: '',
    value: '',
    numeric_value: 0,
    suffix: '+',
    icon: 'trending-up',
    order: 99,
};

export default function AdminImpactStatsPage() {
    return (
        <CrudManager
            resource="impact-stats"
            title="Impact Stats"
            description="Numbers shown in the impact / hero counter section."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['label']}
        />
    );
}
